import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SmartFeedPageLimit extends BaseOption {
  static label = "Num Per Page";
  static descriptionMessage = "Limit when fetching records";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 1,
      max: 100,
      defaultEmptyValue: 24,
    },
  };

  static defaultValue = 24;
}
